import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointProtectResourcesModel extends SharePointResourcesBaseModel {
  userId: string;
  learningDuration: string|null;
  isPremium: boolean|null;
  providerPolicy: string;
}
